module.exports = __webpack_public_path__ + "static/media/dotshorizontal.375d8e6b.png";